import { render, staticRenderFns } from "./BnplApplicationCancel.vue?vue&type=template&id=4a778b57&"
import script from "./BnplApplicationCancel.vue?vue&type=script&lang=js&"
export * from "./BnplApplicationCancel.vue?vue&type=script&lang=js&"
import style0 from "./BnplApplicationCancel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports